import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUpdatePolicy } from "./ethicspolicyAPI";
import swal from 'sweetalert';
export interface UpdatePolicyState {
  updatePolicy: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: UpdatePolicyState = {
    updatePolicy: [],
  status: "idle",
};

export const GetUpdatePolicy = createAsyncThunk(
  "UpdatePolicy/fetchUpdatePolicy",
  async (data:any) => {
    const response = await fetchUpdatePolicy(data);
    return response;
  }
);

export const UpdatePolicySlice = createSlice({
  name: "UpdatePolicy",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUpdatePolicy.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUpdatePolicy.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetUpdatePolicy.fulfilled, (state, action) => {
        state.status = "idle";
        state.updatePolicy = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = UpdatePolicySlice.actions;

export const selectUpdatePolicy = (state: RootState) => {
  return state.UpdatePolicy.updatePolicy;
};

export default UpdatePolicySlice.reducer;
